/* eslint react/prop-types: 0 */
import React from 'react'
import { Accordion, Card, FormInput, Icon, Select } from 'camino-react'

import AssignQueueAction from './AssignQueueAction'
import AutoCloseAction from './AutoCloseAction'
import AutoCloseNoticeAction from './AutoCloseNoticeAction'
import ChangeStatusAction from './ChangeStatusAction'
import SendNotificationAction from './SendNotificationAction'
import SendSurveyAction from './SendSurveyAction'
import SendTeamsNotificationAction from './SendTeamsNotificationAction'
import SetPriorityAction from './SetPriorityAction'
import ConvertToTicket from './ConvertToTicket'

const WorkflowActions = ({ actions, setActions, options, type }) => {
  const actionsForTickets = [
    {
      label: 'Assign Queue',
      value: 'WorkflowActions::AssignQueue'
    },
    {
      label: 'Auto Close',
      value: 'WorkflowActions::SendAutoCloseNotification'
    },
    {
      label: 'Auto Close Notice',
      value: 'WorkflowActions::SendAutoCloseNoticeNotification'
    },
    {
      label: 'Change Status',
      value: 'WorkflowActions::ChangeStatus'
    },
    {
      label: 'Send Notification',
      value: 'WorkflowActions::SendNotification'
    },
    {
      label: 'Send Survey',
      value: 'WorkflowActions::SendSurvey'
    },
    {
      label: 'Send Teams Notification',
      value: 'WorkflowActions::SendMsTeamsNotification'
    },
    {
      label: 'Set Priority',
      value: 'WorkflowActions::SetPriority'
    }
  ]

  const actionsForAlerts = [
    {
      label: 'Convert To Ticket',
      value: 'WorkflowActions::ConvertToTicket'
    }
  ]

  const addAction = (actionType) => {
    setActions([...actions, { type: actionType, operations: {} }])
  }

  const removeAction = (actionType) => {
    setActions(actions.filter(action => action !== actionType))
  }

  const update = (action, key, value) => {
    const newActions = [...actions]
    const actionToUpdate = newActions.find(a => a === action)

    if (key === null) actionToUpdate.operations = value
    else actionToUpdate.operations[key] = value

    setActions(newActions)
  }

  return (
    <Card allowOverflow>
      <div className="flex flex-col items-end">
        <div className="w-full">
          {actions.map(action => (
            <div className="flex">
              <div className="w-full -mb-px">
                <Accordion>
                  {[{
                    title: <div className="text-left">{action.description || action.type.replace('WorkflowActions::', '')}</div>,
                    content: <Action action={action} update={update} options={options} />
                  }]}
                </Accordion>
              </div>

              <div className="border-t border-b border-blue-200 -mb-px pr-3 pt-3">
                <button
                  onClick={() => removeAction(action)}
                  className="text-3xl text-blue-500 duration-300 cursor-pointer hover:text-blue-700"
                  type="button"
                >
                  <Icon type="trash" />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="w-full mt-4">
          <FormInput label="Select Action to add">
            <Select
              options={type === 'Ticket' ? actionsForTickets : actionsForAlerts}
              onChange={e => addAction(e.value)}
            />
          </FormInput>
        </div>
      </div>
    </Card>
  )
}

export default WorkflowActions

const Action = ({ action, update, options }) => {
  let Component = null

  switch (action.type) {
    case 'WorkflowActions::AssignQueue':
      Component = AssignQueueAction
      break
    case 'WorkflowActions::SendAutoCloseNotification':
      Component = AutoCloseAction
      break
    case 'WorkflowActions::SendAutoCloseNoticeNotification':
      Component = AutoCloseNoticeAction
      break
    case 'WorkflowActions::ChangeStatus':
      Component = ChangeStatusAction
      break
    case 'WorkflowActions::SendNotification':
      Component = SendNotificationAction
      break
    case 'WorkflowActions::SendSurvey':
      Component = SendSurveyAction
      break
    case 'WorkflowActions::SendMsTeamsNotification':
      Component = SendTeamsNotificationAction
      break
    case 'WorkflowActions::SetPriority':
      Component = SetPriorityAction
      break
    case 'WorkflowActions::ConvertToTicket':
      Component = ConvertToTicket
      break
    default:
  }

  return (
    <Component
      options={options}
      operations={action.operations}
      update={(key, value) => update(action, key, value)}
    />
  )
}
